export enum CheckboxSize {
  sm = 'sm',
  md = 'md',
  lg = 'lg'
}

export const CHECKBOX_SIZE_PX: Record<CheckboxSize, number> = {
  [CheckboxSize.sm]: 14,
  [CheckboxSize.md]: 16,
  [CheckboxSize.lg]: 22
}
